import { DatasourceFunction } from 'dashboard-engine/types/Datasource';

const fake: DatasourceFunction<null> = () => {
    return Promise.resolve({data: null});
};

export default fake;
